<template lang="pug">
v-content
 v-container(v-if="isIt")
  v-dialog(v-model="readQrcode" max-width="900")
    v-card(v-if="readQrcode")
      v-card-title.title(:class="didScan ? didScan : 'grey.lighten-3'")
        | Scan Inventar
        .text--error &nbsp;{{qrError}}
        .text--success &nbsp;{{lastQrCode}}
        v-spacer
        v-btn(icon @click="readQrcode = false"): v-icon close
      qrcode-stream(@decode="addInventar" @init="onInit")

  v-card
    v-btn(@click="art='Weiss'" color="white" title="frisch installiert" :depressed="art == 'Weiss'" disabled): v-icon donut_large
    v-btn(@click="art='Gelb'" color="yellow" title="unpersonalisiert Setup" :depressed="art == 'Gelb'" disabled): v-icon voice_over_off
    v-btn(@click="art='Grün'" color="success" title="Auslieferung" :depressed="art == 'Grün'"): v-icon check
    v-btn(@click="art='Orange'" color="warning" title="Fehlersuche" :depressed="art == 'Orange'" disabled): v-icon search
    v-btn(@click="art='Rot'" color="error" title="Retour / Garantie" :depressed="art == 'Rot'" disabled): v-icon loop
    v-btn(@click="neuerProzess(art)" v-if="!edit" style="float: right"): v-icon add
    v-btn(@click="edit = null" v-if="edit" style="float: right"): v-icon close

    template(v-if="art == 'Weiss'")
      v-card-text(v-if="edit")
        div(v-if="foto")
          div(style="width: calc(100% - 110px); float: left"): v-text-field(label="User" v-model="email" disabled)
          img(:src="foto" v-if="foto" width="100").ml-2
        v-text-field(v-else label="User" v-model="email" disabled :error-messages="gqlErrorsFor('prozessCreate', 'user')")
        v-autocomplete(label="Inventar" :items="inventar" v-model="edit.inventar" item-value="id" multiple :error-messages="gqlErrorsFor('prozessCreate', 'inventar')")

        v-checkbox(label="Bitlocker" hide-details)
        //- v-checkbox(label="Lokaler Admin / Azure AD Einbindung " hide-details)
        v-checkbox(label="7zip" hide-details)
        v-checkbox(label="Anydesk" hide-details)
        v-checkbox(label="Atera" hide-details)
        //- v-checkbox(label="Eset ( ggf. Microsoft Office Premium Abo ) bei Datenschutz besondere Kategorie. (Ärzte,Hospiz)" hide-details)
        v-checkbox(label="Keepass" hide-details)
        v-checkbox(label="Office (64 Bit + Key kaufen notwendig)" hide-details)
        v-text-field(label="Office Serial" v-if="true")
        v-checkbox(label="Adobe Acrobat" hide-details)
        v-checkbox(label="Firefox" hide-details)
        v-checkbox(label="Erweiterte Systemeinstellungen ( Hardware Reiter)" hide-details)
        v-checkbox(label="HVD-WLAN TEAM/NET" hide-details)
        //- v-checkbox(label="Dokumentation in Excel/Datenbank" hide-details)

        v-btn(@click="save" color="primary" :loading="loading > 0") Speichern

      v-data-table(:items="prozesse" :headers="headersWeiss" v-else-if="isIt && !uid")
        template(slot="items" slot-scope="{item}")
          td {{item.datum}}
          td {{item.inventar.map((i) => i.uid).join(", ")}}
          td {{item.anPerson && item.anPerson.vollerNameEmail || item.an}}
          td {{item.user.email}}
      v-card-text(v-else-if="!$apollo.queries.prozesse.loading && !$apollo.queries.currentUser.loading")
        | Hier gibt es nichts zu sehen

    template(v-if="art == 'Gelb'")
      v-card-text(v-if="edit")
        div(v-if="foto")
          div(style="width: calc(100% - 110px); float: left"): v-text-field(label="User" v-model="email" disabled)
          img(:src="foto" v-if="foto" width="100").ml-2
        v-text-field(v-else label="User" v-model="email" disabled :error-messages="gqlErrorsFor('prozessCreate', 'user')")
        v-autocomplete(label="Inventar" :items="inventar" v-model="edit.inventar" item-value="id" multiple :error-messages="gqlErrorsFor('prozessCreate', 'inventar')")
        v-select(label="Projekt")
        v-select(label="Person")
        radio-group(:items="[{ text: 'Lokaler Admin Team.local' }, { text: 'Azure AD Einbindung' }]")
        radio-group(:items="[{ text: 'Microsoft Office Premium Abo' }, { text: 'Eset' }]")
        //- v-checkbox(label="Eset ( ggf.  ) bei Datenschutz besondere Kategorie. (Ärzte,Hospiz)" hide-details)
        v-checkbox(label="Atera Zuweisung Projekt" hide-details)
        v-checkbox(label="WLAN Standort" hide-details)
        radio-group(:items="[{ text: 'Drucker mit Volumenverfolgung' }, { text: 'Drucker ohne Volumenverfolgung' }]")
        v-select(label="Netzlaufwerke" hide-details multiple)

        v-btn(@click="save" color="primary" :loading="loading > 0") Speichern

      v-data-table(:items="prozesse" :headers="headersWeiss" v-else-if="isIt && !uid")
        template(slot="items" slot-scope="{item}")
          td {{item.datum}}
          td {{item.inventar.map((i) => i.uid).join(", ")}}
          td {{item.anPerson && item.anPerson.vollerNameEmail || item.an}}
          td {{item.user.email}}
      v-card-text(v-else-if="!$apollo.queries.prozesse.loading && !$apollo.queries.currentUser.loading")
        | Hier gibt es nichts zu sehen

    template(v-if="art == 'Grün'")
      v-card-text(v-if="edit")
        div(v-if="foto")
          div(style="width: calc(100% - 110px); float: left"): v-text-field(label="User" v-model="email" disabled)
          img(:src="foto" v-if="foto" width="100").ml-2
        v-text-field(v-else label="User" v-model="email" disabled :error-messages="gqlErrorsFor('prozessCreate', 'user')")
        select-person(label="An Person" allow-blank v-model="edit.anPersonId" :items.sync="personen" :error-messages="gqlErrorsFor('prozessCreate', 'an_person')")
        v-text-field(label="An" v-if="edit.anPersonId == 0" v-model="edit.an")
        label() Unterschrift
        v-btn(@click="clearPad" icon): v-icon clear
        br
        canvas.unterschrift(ref="unterschrift" width="450" height="150")
        .text--error {{gqlErrorsFor('prozessCreate', 'unterschrift').join(", ")}}
        v-autocomplete(label="Inventar" :items="inventar" v-model="edit.inventar" item-value="id" multiple :error-messages="gqlErrorsFor('prozessCreate', 'inventar')" prepend-icon="qr_code_scanner" @click:prepend="readQrcode = true; lastQrCode = null")
        v-btn(@click="save" color="primary" :loading="loading > 0") Speichern

      v-data-table(:items="prozesse" :headers="headersGruen" v-else-if="isIt && !uid")
        template(slot="items" slot-scope="{item}")
          td {{item.datum}}
          td {{item.inventar.map((i) => i.uid).join(", ")}}
          td {{item.anPerson && item.anPerson.vollerNameEmail || item.an}}
          td {{item.user.email}}
      v-card-text(v-else-if="!$apollo.queries.prozesse.loading && !$apollo.queries.currentUser.loading")
        | Hier gibt es nichts zu sehen

</template>

<style scoped>
.unterschrift {
  border: 1px solid black;
}
</style>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import SignaturePad from 'signature_pad'
import moment from 'moment'
require('../../../../node_modules/vue-qrcode-reader/dist/VueQrcodeReader.umd.min.js') // this registers global VueQrcodeReader

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  components: {
    QrcodeStream: VueQrcodeReader.QrcodeStream
  },
  data() {
    return {
      loading: 0,
      didScan: null,
      scanTimeout: null,
      lastQrCode: null,
      readQrcode: false,
      art: "Grün",
      edit: null,
      pad: null,
      padDisabled: true,
      personen: [],
      qrError: null,
      arten: ["Weiss", "Gelb", "Grün", "Orange", "Rot"],
      headersGruen: [
        { text: "Datum", value: "datum" },
        { text: "Inventar", sortable: false },
        { text: "An Person", value: "anPerson.vollerName" },
        { text: "User", value: "user.email" },
      ],
      headersWeiss: [
        { text: "Datum", value: "datum" },
        { text: "Inventar", sortable: false },
        { text: "Todos", sortable: false },
        { text: "User", value: "user.email" },
      ],
    }
  },
  apollo: {
    inventar: {
      query: gql`query {
        inventar {
          id
          art
          model
          hersteller
          seriennr
          uid
        }
      }`,
      update(response) {
        return response.inventar.map((i) => ({ ...i, text: `${i.art} ${i.hersteller} ${i.model} ${i.seriennr} ${i.uid}` }))
      }
    },
    prozesse: {
      query() {
        return gql`query ExtraProzesseVue($art: String) {
          prozesse(where: { art: $art }) {
            id
            art
            datum: datumStr
            an
            anPerson {
              id
              vollerNameEmail
            }
            inventar {
              id
              uid
            }
            user {
              id
              email
            }
          }
        }`
      },
      variables() {
        return { art: this.art }
      },
      skip() {
        return !this.isIt && !this.uid
      }
    },
    currentUser: {
      query: gql`query ExtraMeinProjektCurrentUser {
        currentUser {
          id
          email
          vollerName
          rollen
          person {
            foto(size: "100x100")
          }
        }
      }`
    },
  },
  computed: {
    hasPad() {
      return this.art == 'Grün'
    },
    uid() {
      return this.$route.params.uid
    },
    isIt() {
      const rollen = ["admin", "it", "inventur"]
      const user = this.currentUser
      return !!(user && user.rollen && user.rollen.some((r) => rollen.indexOf(r) > -1))
    },
    email() {
      return this.currentUser && this.currentUser.email || this.currentUser.vollerName
    },
    foto() {
      return this.currentUser && this.currentUser.person && this.currentUser.person.foto
    }
  },
  methods: {
    async onInit(promise) {
      this.qrError = null
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.qrError = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.qrError = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.qrError = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.qrError = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.qrError = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.qrError = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.qrError = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.qrError = `ERROR: Camera error (${error.name})`;
        }
      }
    },
    addInventar(result) {
      if (/^https:\/\/box.hvd-bb.de\/inventar\//.test(result)) {
        const uid = result.replace("https:\/\/box.hvd-bb.de\/inventar\/", "")
        this.qrError = null
        this.lastQrCode = uid
        console.log(this.edit.inventar);
        const id = this.inventar.find((i) => i.uid == uid)
        if (id) {
          if (this.edit.inventar.indexOf(id.id) === -1) {
            this.edit.inventar.push(id.id)
            this.didScan = "success white--text"
          } else {
            this.didScan = "warning white--text"
          }
        } else {
          this.didScan = "error white--text"
        }
        if (this.scanTimeout) {
          clearTimeout(this.scanTimeout)
        }
        this.scanTimeout = setTimeout(() => {
          this.didScan = null
        }, 600)
      } else {
        this.lastQrCode = null
        this.qrError = result
      }
    },
    clearPad() {
      this.pad.clear()
      this.pad.on()
      this.padDisabled = false
    },
    unterschriftImageUrl() {
      if (this.hasPad && !this.pad.isEmpty()) {
        if (!this.padDisabled) {
          const ctx = this.$refs.unterschrift.getContext("2d")
          ctx.font = "42px serif"
          ctx.textAlign = "center"
          ctx.fillStyle = "#02050940"
          ctx.fillText(moment().format("DD. MM. Y HH:mm"), 450/2, 100, 450)
          this.padDisabled = true
          this.pad.off()
        }
        return this.pad.toDataURL()
      }
    },
    neuerProzess(art) {
      if (art == "Weiss") {
        this.edit = {
          art: art,
          userId: this.currentUser.id,
          inventar: [],
          todos: [],
        }
      } else if (art == 'Gelb') {
        this.edit = {
          art: art,
          an: "",
          anPersonId: null,
          userId: this.currentUser.id,
          unterschriftImageUrl: null,
          inventar: [],
        }
      } else if (art == 'Grün') {
        this.edit = {
          art: art,
          an: "",
          anPersonId: null,
          userId: this.currentUser.id,
          unterschriftImageUrl: null,
          inventar: [],
        }
      }
      this.gqlClearAllErrors()
      if (this.hasPad) {
        this.$nextTick(() => {
          if (!this.pad) {
            this.pad = new SignaturePad(this.$refs.unterschrift, { penColor: "#010604A0" })
            window.p = this.pad
          } else {
            this.pad.clear()
            this.pad.on()
          }
          this.padDisabled = false
        })
      }
    },
    save() {
      if (this.loading > 0) {
        return
      }
      const variables = {
        ...this.edit,
        anPersonId: this.edit.anPersonId == 0 ? null : this.edit.anPersonId,
        unterschriftImageUrl: this.unterschriftImageUrl(),
      }

      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation ExtraProzesseVueSave(
          $art: String
          $userId: ID
          $anPersonId: ID
          $an: String
          $unterschriftImageUrl: String
          $inventar: [ID]
        ) {
          prozessCreate(
            art: $art
            userId: $userId
            anPersonId: $anPersonId
            an: $an
            unterschriftImageUrl: $unterschriftImageUrl
            inventar: $inventar
          ) {
            id
          }
        }`,
        variables,
      }).then((response) => {
        this.loading--
        this.edit = null
        this.$apollo.queries.prozesse.refetch()
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    }
  }
}
</script>
